"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUID = exports.getUser = void 0;

var _path = _interopRequireDefault(require("path"));

var _core = require("../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var username, config, user, url, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            username = _ref.username, config = _ref.config;
            user = null;
            url = _path.default.join(_core.apiPath, 'users', username);
            _context.prev = 3;
            _context.next = 6;
            return (0, _core.get)({
              url: url,
              config: config
            });

          case 6:
            user = _context.sent;
            _context.next = 14;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            errorMessage = _context.t0 && _context.t0.message ? _context.t0.message : '';

            if (!(errorMessage.match(_core.ERROR_SERVER_UNREACHABLE) || errorMessage.match(_core.ERROR_NETWORK_DISCONNECTED))) {
              _context.next = 14;
              break;
            }

            throw _context.t0;

          case 14:
            return _context.abrupt("return", user);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));

  return function getUser(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getUser = getUser;

var getUID = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var username, config, uid, user;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            username = _ref3.username, config = _ref3.config;
            _context2.prev = 1;
            _context2.next = 4;
            return getUser({
              username: username,
              config: config
            });

          case 4:
            user = _context2.sent;

            if (user) {
              uid = user.id;
            }

            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            uid = null;

          case 11:
            return _context2.abrupt("return", uid);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function getUID(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getUID = getUID;